import React from "react";
import { Sparkles, Globe, Shield, Headphones } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { useI18n } from "../i18n-context";
import { WAREHOUSE_IMG } from "../assets";

export default function AboutPage() {
  const { t } = useI18n();
  const icons = [Sparkles, Globe, Shield, Headphones];

  return (
    <>
      <PageHeader kicker={t.about.kicker} title={t.about.title} lead={t.about.lead} />

      <section className="section-pad">
        <div className="container grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="rounded-3xl overflow-hidden border-2 border-brand-ink/10 mb-8">
              <img src={WAREHOUSE_IMG} alt="Akwaan warehouse" className="w-full h-80 object-cover" />
            </div>

            <div className="grid sm:grid-cols-2 gap-5">
              <div className="rounded-3xl bg-brand-blue text-white p-8" data-testid="about-mission">
                <div className="font-display font-extrabold text-3xl md:text-4xl mb-4 leading-none">
                  {t.about.missionTitle}
                </div>
                <p className="text-lg font-medium leading-relaxed">{t.about.mission}</p>
              </div>
              <div className="rounded-3xl bg-brand-ink text-white p-8" data-testid="about-vision">
                <div className="font-display font-extrabold text-3xl md:text-4xl mb-4 leading-none text-brand-orange">
                  {t.about.visionTitle}
                </div>
                <p className="text-lg font-medium leading-relaxed">{t.about.vision}</p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-6">
            <div className="grid sm:grid-cols-2 gap-4">
              {t.about.pillars.map((p, i) => {
                const Icon = icons[i];
                return (
                  <div
                    key={i}
                    className="card-tilt rounded-2xl bg-white border border-brand-ink/10 p-6"
                    data-testid={`about-pillar-${i}`}
                  >
                    <div className="h-12 w-12 rounded-xl bg-brand-orange/10 flex items-center justify-center mb-4">
                      <Icon className="h-6 w-6 text-brand-orange" />
                    </div>
                    <div className="font-display font-bold text-lg text-brand-ink mb-2">{p.t}</div>
                    <div className="text-sm text-brand-ink/60 leading-relaxed">{p.d}</div>
                  </div>
                );
              })}
            </div>

            {/* Stats highlight */}
            <div className="rounded-3xl bg-brand-paper border border-brand-ink/10 p-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {[
                  { v: "2.7M+", l: t.hero.stat1 },
                  { v: "<18h", l: t.hero.stat2 },
                  { v: "18", l: t.hero.stat3 },
                  { v: "24/7", l: t.hero.stat4 },
                ].map((s, i) => (
                  <div key={i} className="border-t-2 border-brand-ink/10 pt-3">
                    <div className="text-3xl font-display font-extrabold text-brand-ink">{s.v}</div>
                    <div className="text-xs text-brand-ink/60 mt-1 leading-snug">{s.l}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
